export interface PreviewLocationState {
  from?: string;
}

export const previewReturnPath = (state: unknown): string | null => {
  const from = (state as PreviewLocationState | null)?.from;
  if (typeof from === 'string' && from.startsWith('/')) {
    return from;
  }
  return null;
};

export const previewReturnLabel = (from: string | null): string => {
  switch (from) {
    case '/edit':
      return 'Back to editor';
    case '/decks':
      return 'Back to my decks';
    case '/':
      return 'Back to templates';
    default:
      return 'Back';
  }
};
